import { BackgroundCircle } from './BackgroundCircle'
import { Container } from './Container'
import { PrimaryCircle } from './PrimaryCircle'
import { SecondaryCircle } from './SecondaryCircle'

type Props = {
	size?: number
	strokeWidth?: number
}

export const Spinner = ({ size = 80, strokeWidth = 10 }: Props) => (
	<Container size={size}>
		<svg viewBox={`0 0 ${size * 2} ${size * 2}`} xmlns='http://www.w3.org/2000/svg'>
			<BackgroundCircle cx={size} cy={size} r={size - strokeWidth / 2} strokeWidth={strokeWidth} pathLength='100' />
			<SecondaryCircle cx={size} cy={size} r={size - strokeWidth / 2} strokeWidth={strokeWidth} pathLength='200' />
			<PrimaryCircle cx={size} cy={size} r={size - strokeWidth / 2} strokeWidth={strokeWidth} pathLength='100' />
		</svg>
	</Container>
)
